import _asyncToGenerator from "/opt/build/repo/front-end/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { toArray } from './util';
import { fetchAsDataURL } from './dataurl';
import { shouldEmbed, embedResources } from './embed-resources';
var cssFetchCache = {};
function fetchCSS(_x) {
  return _fetchCSS.apply(this, arguments);
}
function _fetchCSS() {
  _fetchCSS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
    var cache, res, cssText;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cache = cssFetchCache[url];
            if (!(cache != null)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", cache);
          case 3:
            _context.next = 5;
            return fetch(url);
          case 5:
            res = _context.sent;
            _context.next = 8;
            return res.text();
          case 8:
            cssText = _context.sent;
            cache = {
              url: url,
              cssText: cssText
            };
            cssFetchCache[url] = cache;
            return _context.abrupt("return", cache);
          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchCSS.apply(this, arguments);
}
function embedFonts(_x2, _x3) {
  return _embedFonts.apply(this, arguments);
}
function _embedFonts() {
  _embedFonts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data, options) {
    var cssText, regexUrl, fontLocs, loadFonts;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            cssText = data.cssText;
            regexUrl = /url\(["']?([^"')]+)["']?\)/g;
            fontLocs = cssText.match(/url\([^)]+\)/g) || [];
            loadFonts = fontLocs.map( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(loc) {
                var url;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        url = loc.replace(regexUrl, '$1');
                        if (!url.startsWith('https://')) {
                          url = new URL(url, data.url).href;
                        }
                        return _context2.abrupt("return", fetchAsDataURL(url, options.fetchRequestInit, function (_ref2) {
                          var result = _ref2.result;
                          cssText = cssText.replace(loc, "url(".concat(result, ")"));
                          return [loc, result];
                        }));
                      case 3:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));
              return function (_x12) {
                return _ref.apply(this, arguments);
              };
            }());
            return _context3.abrupt("return", Promise.all(loadFonts).then(function () {
              return cssText;
            }));
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _embedFonts.apply(this, arguments);
}
function parseCSS(source) {
  if (source == null) {
    return [];
  }
  var result = [];
  var commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
  // strip out comments
  var cssText = source.replace(commentsRegex, '');
  // eslint-disable-next-line prefer-regex-literals
  var keyframesRegex = new RegExp('((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})', 'gi');
  // eslint-disable-next-line no-constant-condition
  while (true) {
    var matches = keyframesRegex.exec(cssText);
    if (matches === null) {
      break;
    }
    result.push(matches[0]);
  }
  cssText = cssText.replace(keyframesRegex, '');
  var importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
  // to match css & media queries together
  var combinedCSSRegex = '((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]' + '*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})';
  // unified regex
  var unifiedRegex = new RegExp(combinedCSSRegex, 'gi');
  // eslint-disable-next-line no-constant-condition
  while (true) {
    var _matches = importRegex.exec(cssText);
    if (_matches === null) {
      _matches = unifiedRegex.exec(cssText);
      if (_matches === null) {
        break;
      } else {
        importRegex.lastIndex = unifiedRegex.lastIndex;
      }
    } else {
      unifiedRegex.lastIndex = importRegex.lastIndex;
    }
    result.push(_matches[0]);
  }
  return result;
}
function getCSSRules(_x4, _x5) {
  return _getCSSRules.apply(this, arguments);
}
function _getCSSRules() {
  _getCSSRules = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(styleSheets, options) {
    var ret, deferreds;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            ret = [];
            deferreds = []; // First loop inlines imports
            styleSheets.forEach(function (sheet) {
              if ('cssRules' in sheet) {
                try {
                  toArray(sheet.cssRules || []).forEach(function (item, index) {
                    if (item.type === CSSRule.IMPORT_RULE) {
                      var importIndex = index + 1;
                      var url = item.href;
                      var deferred = fetchCSS(url).then(function (metadata) {
                        return embedFonts(metadata, options);
                      }).then(function (cssText) {
                        return parseCSS(cssText).forEach(function (rule) {
                          try {
                            sheet.insertRule(rule, rule.startsWith('@import') ? importIndex += 1 : sheet.cssRules.length);
                          } catch (error) {
                            console.error('Error inserting rule from remote css', {
                              rule: rule,
                              error: error
                            });
                          }
                        });
                      }).catch(function (e) {
                        console.error('Error loading remote css', e.toString());
                      });
                      deferreds.push(deferred);
                    }
                  });
                } catch (e) {
                  var inline = styleSheets.find(function (a) {
                    return a.href == null;
                  }) || document.styleSheets[0];
                  if (sheet.href != null) {
                    deferreds.push(fetchCSS(sheet.href).then(function (metadata) {
                      return embedFonts(metadata, options);
                    }).then(function (cssText) {
                      return parseCSS(cssText).forEach(function (rule) {
                        inline.insertRule(rule, sheet.cssRules.length);
                      });
                    }).catch(function (err) {
                      console.error('Error loading remote stylesheet', err.toString());
                    }));
                  }
                  console.error('Error inlining remote css file', e.toString());
                }
              }
            });
            return _context4.abrupt("return", Promise.all(deferreds).then(function () {
              // Second loop parses rules
              styleSheets.forEach(function (sheet) {
                if ('cssRules' in sheet) {
                  try {
                    toArray(sheet.cssRules || []).forEach(function (item) {
                      ret.push(item);
                    });
                  } catch (e) {
                    console.error("Error while reading CSS rules from ".concat(sheet.href), e.toString());
                  }
                }
              });
              return ret;
            }));
          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getCSSRules.apply(this, arguments);
}
function getWebFontRules(cssRules) {
  return cssRules.filter(function (rule) {
    return rule.type === CSSRule.FONT_FACE_RULE;
  }).filter(function (rule) {
    return shouldEmbed(rule.style.getPropertyValue('src'));
  });
}
function parseWebFontRules(_x6, _x7) {
  return _parseWebFontRules.apply(this, arguments);
}
function _parseWebFontRules() {
  _parseWebFontRules = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(node, options) {
    var styleSheets, cssRules;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(node.ownerDocument == null)) {
              _context5.next = 2;
              break;
            }
            throw new Error('Provided element is not within a Document');
          case 2:
            styleSheets = toArray(node.ownerDocument.styleSheets);
            _context5.next = 5;
            return getCSSRules(styleSheets, options);
          case 5:
            cssRules = _context5.sent;
            return _context5.abrupt("return", getWebFontRules(cssRules));
          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _parseWebFontRules.apply(this, arguments);
}
export function getWebFontCSS(_x8, _x9) {
  return _getWebFontCSS.apply(this, arguments);
}
function _getWebFontCSS() {
  _getWebFontCSS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(node, options) {
    var rules, cssTexts;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return parseWebFontRules(node, options);
          case 2:
            rules = _context6.sent;
            _context6.next = 5;
            return Promise.all(rules.map(function (rule) {
              var baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
              return embedResources(rule.cssText, baseUrl, options);
            }));
          case 5:
            cssTexts = _context6.sent;
            return _context6.abrupt("return", cssTexts.join('\n'));
          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getWebFontCSS.apply(this, arguments);
}
export function embedWebFonts(_x10, _x11) {
  return _embedWebFonts.apply(this, arguments);
}
function _embedWebFonts() {
  _embedWebFonts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(clonedNode, options) {
    var cssText, styleNode, sytleContent;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!(options.fontEmbedCSS != null)) {
              _context7.next = 4;
              break;
            }
            _context7.t0 = options.fontEmbedCSS;
            _context7.next = 12;
            break;
          case 4:
            if (!options.skipFonts) {
              _context7.next = 8;
              break;
            }
            _context7.t1 = null;
            _context7.next = 11;
            break;
          case 8:
            _context7.next = 10;
            return getWebFontCSS(clonedNode, options);
          case 10:
            _context7.t1 = _context7.sent;
          case 11:
            _context7.t0 = _context7.t1;
          case 12:
            cssText = _context7.t0;
            if (cssText) {
              styleNode = document.createElement('style');
              sytleContent = document.createTextNode(cssText);
              styleNode.appendChild(sytleContent);
              if (clonedNode.firstChild) {
                clonedNode.insertBefore(styleNode, clonedNode.firstChild);
              } else {
                clonedNode.appendChild(styleNode);
              }
            }
          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _embedWebFonts.apply(this, arguments);
}